import { SelectOption } from 'govwell-ui/components/Select/types'
import { FeeScheduleFragment } from 'types/graphql'

import FeeScheduleSelect from 'src/components/Selects/FeeScheduleSelect'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  feeSchedules?: FeeScheduleFragment[]
  field: TanstackField<number | undefined, TKey>
  caption?: React.ReactNode
  isClearable?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  width?: React.CSSProperties['width']
  isDisabled?: boolean
  placeholder?: string
  getIsOptionDisabled?: (option: SelectOption<number>) => boolean
}

const FeeScheduleSelectField = <TKey extends string>({
  feeSchedules,
  caption,
  field,
  isClearable,
  isRequired,
  label,
  width,
  isDisabled,
  placeholder,
  getIsOptionDisabled,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage
  return (
    <FeeScheduleSelect
      feeSchedules={feeSchedules}
      caption={caption}
      errorMessage={errorMessage}
      isInvalid={isInvalid}
      isClearable={isClearable}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      width={width}
      isDisabled={isDisabled}
      placeholder={placeholder}
      onValueChange={(value) => field.setValue(value ?? undefined)}
      value={field.state.value}
      getIsOptionDisabled={getIsOptionDisabled}
    />
  )
}

export default FeeScheduleSelectField
